// Bazaarvoice/iovation device fingerprint for syndication eligibility
// (Authenticity Policy requires it alongside UserEmail and the author's IP).
// Shared by product-registration-form.liquid and
// template-share-your-experience.liquid - both load iovation-loader.js
// (which exposes window.IGLOO) then this file, in that order.
//
// The blackbox value fills in over time as iovation gathers signals -
// finished:true means it has nothing more to add, but a partial blackbox is
// still valid to submit, so this caps the wait instead of blocking
// submission on it indefinitely. It also waits for window.IGLOO itself to
// exist, not just for the blackbox to finish - iovation-loader.js is loaded
// with `defer`, so a visitor who reaches Submit fast enough can otherwise
// hit this before the script has even run, silently sending an empty
// fingerprint. Wrapped in try/catch so a throw from IGLOO mid-poll resolves
// with whatever we have instead of hanging the calling Promise.all forever.
function getDeviceFingerprint() {
    return new Promise(function (resolve) {
        var start = Date.now();
        var MAX_WAIT_MS = 3000;
        (function poll() {
            var timedOut = Date.now() - start > MAX_WAIT_MS;
            try {
                if (window.IGLOO && typeof window.IGLOO.getBlackbox === 'function') {
                    var bb = window.IGLOO.getBlackbox();
                    if ((bb && bb.finished) || timedOut) {
                        resolve(bb && bb.blackbox ? bb.blackbox : '');
                        return;
                    }
                } else if (timedOut) {
                    resolve('');
                    return;
                }
            } catch (error) {
                resolve('');
                return;
            }
            setTimeout(poll, 200);
        })();
    });
}
